/**
 * MB Collection All Products — real-time collection-tab filtering.
 * Each block picks a collection; clicking its tab, sort dropdown, or
 * View More button fetches the collection page via Shopify's Section
 * Rendering API (?section_id=...) and swaps the grid HTML in place.
 * This is used instead of /products.json because products.json does
 * NOT honor sort_by — only the real collection page route does.
 */
(function () {
  var roots = document.querySelectorAll('.mb-collection-all');

  roots.forEach(function (root) {
    var gridWrap    = root.querySelector('[data-mb-grid-wrap]');
    var grid        = root.querySelector('[data-mb-grid]');
    var tabsWrap    = root.querySelector('[data-mb-tabs]');
    var sortSelect  = root.querySelector('[data-mb-sort-select]');
    var countEl     = root.querySelector('[data-mb-total-count]');
    var pagCountEl  = root.querySelector('[data-mb-pag-count]');
    var viewMoreBtn = root.querySelector('[data-mb-view-more]');
    var sectionId   = root.getAttribute('data-mb-section-id');

    var perPage = parseInt(root.getAttribute('data-mb-per-page'), 10) || 16;

    var state = {
      handle: root.getAttribute('data-mb-active-handle'),
      page: 1,
      sort: sortSelect ? sortSelect.value : 'manual'
    };

    // Put this once, near the top of the script (outside loadCollection)
      var MB_LANG = (
        (window.Shopify && Shopify.locale) ||
        document.documentElement.lang ||
        'nl'
      ).toLowerCase();

      var MB_STRINGS = MB_LANG.indexOf('en') === 0
        ? {
            empty: 'No products found.',
            viewMore: 'View More',
            showing: function (n) { return 'Showing ' + n + (n === 1 ? ' product' : ' products'); },
            count: function (n) { return n + (n === 1 ? ' product' : ' products'); }
          }
        : {
            empty: 'Geen producten gevonden.',
            viewMore: 'Meer laden',
            showing: function (n) { return n + ' ' + (n === 1 ? 'product' : 'producten') + ' getoond'; },
            count: function (n) { return n + ' ' + (n === 1 ? 'product' : 'producten'); }
          };

      function loadCollection(handle, page, append) {
        gridWrap.classList.add('is-loading');

        // Use the locale-aware root so the fetched HTML is in the active language (/en/ or /)
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var url = root + 'collections/' + handle + '/?page=' + page + '&section_id=' + sectionId;
        if (state.sort && state.sort !== 'manual') {
          url += '&sort_by=' + encodeURIComponent(state.sort);
        }

        fetch(url)
          .then(function (res) {
            if (!res.ok) throw new Error('Request failed');
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-mb-grid]');
            var newProductCount = newGrid
              ? newGrid.querySelectorAll('.mb-product-card').length
              : 0;

            if (newGrid) {
              if (append) {
                Array.prototype.forEach.call(newGrid.children, function (child) {
                  grid.appendChild(child);
                });
              } else {
                grid.innerHTML = newGrid.innerHTML;
              }
            } else if (!append) {
              grid.innerHTML = '<p class="mb-collection-all__empty">' + MB_STRINGS.empty + '</p>';
            }

            bindAtcEvents();

            var total = grid.querySelectorAll('.mb-product-card').length;
            if (countEl) countEl.textContent = MB_STRINGS.count(total);
            if (pagCountEl) pagCountEl.textContent = MB_STRINGS.showing(total);

            if (viewMoreBtn) {
              viewMoreBtn.disabled = false;
              viewMoreBtn.textContent = MB_STRINGS.viewMore;
              viewMoreBtn.style.display = newProductCount < perPage ? 'none' : '';
            }

            gridWrap.classList.remove('is-loading');
          })
          .catch(function () {
            gridWrap.classList.remove('is-loading');
            if (viewMoreBtn) {
              viewMoreBtn.disabled = false;
              viewMoreBtn.textContent = MB_STRINGS.viewMore;
            }
          });
      }

    function bindTabEvents() {
      if (!tabsWrap) return;
      tabsWrap.querySelectorAll('[data-mb-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabsWrap.querySelectorAll('[data-mb-tab]').forEach(function (t) {
            t.classList.remove('is-active');
          });
          tab.classList.add('is-active');

          state.handle = tab.getAttribute('data-collection-handle');
          state.page = 1;
          loadCollection(state.handle, 1, false);
        });
      });
    }

    function bindSortEvents() {
      if (!sortSelect) return;
      sortSelect.addEventListener('change', function () {
        state.sort = sortSelect.value;
        state.page = 1;
        loadCollection(state.handle, 1, false);
      });
    }

    function bindViewMoreEvents() {
      if (!viewMoreBtn) return;
      viewMoreBtn.addEventListener('click', function () {
        state.page += 1;
        viewMoreBtn.disabled = true;
        viewMoreBtn.textContent = 'Laden…';
        loadCollection(state.handle, state.page, true);
      });
    }

    function bindAtcEvents() {
      root.querySelectorAll('[data-mb-atc-form]').forEach(function (form) {
        if (form.dataset.mbBound) return;
        form.dataset.mbBound = 'true';

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var button = form.querySelector('.mb-atc-button');
          if (!button || button.disabled) return;
          var originalText = button.textContent;
          button.disabled = true;
          button.textContent = 'Toevoegen…';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: form.querySelector('input[name="id"]').value, quantity: 1 }] })
          })
            .then(function (res) { return res.json(); })
            .then(function () {
              button.textContent = 'Toegevoegd';
              button.classList.add('is-added');
              document.dispatchEvent(new CustomEvent('mb:cart:updated'));
              setTimeout(function () {
                button.textContent = originalText;
                button.classList.remove('is-added');
                button.disabled = false;
              }, 1800);
            })
            .catch(function () {
              button.textContent = originalText;
              button.disabled = false;
            });
        });
      });
    }

    function bindSwatchEvents() {
      root.addEventListener('click', function (e) {
        var swatch = e.target.closest('[data-mb-swatch]');
        if (!swatch) return;

        var card = swatch.closest('.mb-product-card');
        if (!card) return;

        var mainImg = card.querySelector('.mb-product-card__image');
        var newSrc = swatch.getAttribute('data-mb-swatch-src');
        if (mainImg && newSrc) mainImg.src = newSrc;

        card.querySelectorAll('[data-mb-swatch]').forEach(function (s) {
          s.classList.remove('is-active');
        });
        swatch.classList.add('is-active');
      });
    }

    bindTabEvents();
    bindSortEvents();
    bindViewMoreEvents();
    bindAtcEvents();
    bindSwatchEvents();
  });
})();